import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import LoadingIcon from "../../../../components/LoadingIcon";
import ResizableDrawer from "../../../../components/ResizableDrawer";
import SvgToIcon from "../../../../icons/SvgToIcon";
import VulnerabilitiesTable from "../../../posture/vulnerabilities/VulnerabilitiesTable";
import { topExposureDaysCalculate } from "../../../posture/vulnerabilities/utils";
import { icons } from "../icons/iconExport";

const VulnerabilitiesDrawer = ({
  open,
  setOpen,
  entityVulnerabilities,
  entityVulnerabilitiesIsLoading,
}) => {
  const { trackEvent } = useAPI();
  const [topExposureDays, setTopExposureDays] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const onRowClick = (row) => {
    window.open(
      `/posture/vulnerabilities?cve=${row.row.vulnerability_id}`,
      "_blank"
    );
    trackEvent("User open Vulnerability Drawer");
  };
  useEffect(() => {
    if (entityVulnerabilities) {
      setTopExposureDays(topExposureDaysCalculate(entityVulnerabilities));
    }
  }, [entityVulnerabilities]);

  const onDrawerClose = () => {
    searchParams.delete("vulnerabilities");
    setSearchParams(searchParams.toString());
  };

  return (
    <ResizableDrawer
      initialWidth={700}
      minWidth={700}
      PaperProps={{
        style: {
          overflowY: "auto",
          borderRadius: "8px 0 0 0",
          padding: 3,
        },
      }}
      anchor="right"
      open={open}
      onClose={onDrawerClose}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          padding: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
          }}
        >
          <SvgToIcon
            IconLogo={icons.cveIcon}
            style={{
              width: "24px",
              height: "24px",
            }}
          />
          <Typography variant="h5">Vulnerabilities</Typography>
        </Box>
        <Box sx={{ width: "100%" }}>
          {entityVulnerabilities?.length > 0 ? (
            <VulnerabilitiesTable
              dataIsLoading={entityVulnerabilitiesIsLoading}
              vulnerabilities={entityVulnerabilities}
              gridRef={null}
              onRowClick={(row) => onRowClick(row)}
              topExposureDays={topExposureDays}
              filterColumns={[
                "vulnerability_id",
                "breeze_score",
                "severity",
                "exploit",
                "published_date",
              ]}
            />
          ) : entityVulnerabilitiesIsLoading ? (
            <LoadingIcon size={16} />
          ) : null}
        </Box>
      </Box>
    </ResizableDrawer>
  );
};

export default VulnerabilitiesDrawer;
